import script from "./ProxySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProxySettings.vue?vue&type=script&setup=true&lang=js"

import "./ProxySettings.vue?vue&type=style&index=0&id=57a81f91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a81f91"]])

export default __exports__